import React from 'react';
import GoodTouch2023 from 'views/GoodTouch2023';

const LifeSkillPage = () => {
  return <GoodTouch2023/>;
};

export default LifeSkillPage;